import { takeLatest, call, select, put } from 'redux-saga/effects';

import {
  USER_LOGOUT_CLEAR,
  PERSISTED_USER_ACTION_TYPES,
} from 'constants/ActionTypes';
import { PERSISTED_ACTION_TYPES as PERSISTED_APPOINTMENTS } from 'modules/appointments/actionTypes';
import { PERSISTED_ACTION_TYPES as PERSISTED_AUDIT } from 'modules/audits/actionTypes';
import { SIGN_OUT_EMERGENCY } from 'modules/auth/actionTypes';
import { PERSISTED_ACTION_TYPES as PERSISTED_CAMERAS } from 'modules/cameras/actionTypes';
import { PERSISTED_ACTION_TYPES as PERSISTED_CAMPAIGNS } from 'modules/campaigns/actionTypes';
import { PERSISTED_CHAT } from 'modules/chat/actionTypes';
import { PERSISTED_DEVICES } from 'modules/devices/actionTypes';
import { PERSISTED_ACTION_TYPES as PERSISTED_FOLLOW_UP } from 'modules/followUp/actionTypes';
import { PERSISTED_ACTION_TYPES as PERSISTED_HARDWARES } from 'modules/hardwares/actionTypes';
import { clearInterventionsTemporaryFilters } from 'modules/interventions/actions/filters';
import { PERSISTED_INTERVENTION, PERSISTED_MOBILITY_ACTION_TYPES as PERSISTED_MOBILITY } from 'modules/interventions/actionTypes';
import { PERSISTED_ACTION_TYPES as PERSISTED_KIOSKS } from 'modules/kiosks/actionTypes';
import { PERSISTED_ACTION_TYPES as PERSISTED_LEADS } from 'modules/leads/actionTypes';
import * as actions from 'modules/localStorage/actions';
import { SAVE } from 'modules/localStorage/actionTypes';
import { PERSISTED_ACTION_TYPES as PERSISTED_PAYMENTS } from 'modules/payments/actionTypes';
import { PERSISTED_ACTION_TYPES as PERSISTED_CALENDAR } from 'modules/planning/actionTypes';
import { PERSISTED_ACTION_TYPES as PERSISTED_RELEASES } from 'modules/releases/actionTypes';

import type { RootState } from 'reducers/index';
import * as StateLoader from 'services/StateLoader';

const saveActions = [
  SAVE,
  ...PERSISTED_INTERVENTION,
  ...PERSISTED_APPOINTMENTS,
  ...PERSISTED_CALENDAR,
  ...PERSISTED_CHAT,
  ...PERSISTED_DEVICES,
  ...PERSISTED_USER_ACTION_TYPES,
  ...PERSISTED_LEADS,
  ...PERSISTED_KIOSKS,
  ...PERSISTED_AUDIT,
  ...PERSISTED_CAMERAS,
  ...PERSISTED_CAMPAIGNS,
  ...PERSISTED_FOLLOW_UP,
  ...PERSISTED_MOBILITY,
  ...PERSISTED_HARDWARES,
  ...PERSISTED_PAYMENTS,
  ...PERSISTED_RELEASES,
];
const clearActions = [SIGN_OUT_EMERGENCY, USER_LOGOUT_CLEAR];

function* save() {
  try {
    const state: RootState = yield select();
    yield call(StateLoader.saveState, state);
  } catch (message) {
    yield put(actions.saveFailure(message));
  }
}

function* clear() {
  yield call(StateLoader.removeState);
  yield put(clearInterventionsTemporaryFilters());
}

export default function* localStorageSagas() {
  yield takeLatest(saveActions, save);
  yield takeLatest(clearActions, clear);
}
